import React, { useMemo, useState } from "react";

import { PathResolver, withResolvePaths } from "../../../../withResolvePaths";
import { createHocDisplayName } from "../../../../TypingUtils";

import { CrossfitBodyProps, CrossfitTableBody } from "./CrossfitTableBody";
import {
    CrossfitTableBodyRequestEmptyRowContext,
    ICrossfitTableBodyRequestEmptyRowContext,
} from "./CrossfitTableBodyRequestEmptyRowContext";

export interface CrossfitTableContainerProps extends CrossfitBodyProps {
    children: JSX.Element;
    resolvePath: PathResolver;
}

function withCrossfitTableBodyWrapper() {
    const WithCrossfitTableBodyWrapper: React.FC<CrossfitTableContainerProps> = ownProps => {
        const { children } = ownProps;
        const [emptyRowRequired, setEmptyRowRequired] = useState(false);

        const emptyRowRequesterContext: ICrossfitTableBodyRequestEmptyRowContext = useMemo(() => {
            let prevValue = emptyRowRequired;
            const requestedEmptyRowSet = new Set<string>();
            return {
                requestEmptyRow: (clientId: string, required: boolean) => {
                    if (required) {
                        requestedEmptyRowSet.add(clientId);
                    } else {
                        requestedEmptyRowSet.delete(clientId);
                    }
                    const isRequired = requestedEmptyRowSet.size > 0;
                    if (prevValue != isRequired) {
                        prevValue = isRequired;
                        setEmptyRowRequired(isRequired);
                    }
                },
            };
        }, []);

        return (
            <CrossfitTableBodyRequestEmptyRowContext.Provider value={emptyRowRequesterContext}>
                <CrossfitTableBody {...ownProps} emptyRowRequired={emptyRowRequired}>
                    {children}
                </CrossfitTableBody>
            </CrossfitTableBodyRequestEmptyRowContext.Provider>
        );
    };

    WithCrossfitTableBodyWrapper.displayName = createHocDisplayName(CrossfitTableBody, "CrossfitTableBodyWrapper");
    return WithCrossfitTableBodyWrapper;
}

export const CrossfitTableBodyContainer = React.memo(withResolvePaths(withCrossfitTableBodyWrapper()));
